// extracted by mini-css-extract-plugin
module.exports = {"mailing-list__drawer-inner":"mailing-list__drawer-inner__RbYGdDHWUodVV"};